import { useEnLigne } from '../routes/racine/BandeauHorsLigne.js';
import { useConsultationHorsLigne } from '../horsLigne/index.js';
import { Image as IconeImage } from 'lucide-react';
import type { JSX } from 'react';
import { useState } from 'react';
import styles from './VignetteOeuvre.module.css';

export interface VignetteOeuvreProps {
  /** URL d'aperçu signée, rendue avec la liste (`vignettes`) ; `null` sans image. */
  url: string | null;
  /** `sm` : ligne de catalogue ; `md` : liste de l'artiste ; `lg` : carte. */
  taille?: 'sm' | 'md' | 'lg';
  className?: string;
  'data-ui'?: string;
}

/**
 * L'œuvre entière sur un passe-partout (`contain`, jamais recadrée), ou un
 * cadre vide. Décorative : le titre voisin nomme l'œuvre. Une URL expirée
 * (signature de deux minutes) retombe sur le cadre vide jusqu'à la suivante.
 */
export function VignetteOeuvre({
  url,
  taille = 'sm',
  className,
  'data-ui': dataUi,
}: VignetteOeuvreProps): JSX.Element {
  const [urlEnEchec, setUrlEnEchec] = useState<string | null>(null);
  const enLigne = useEnLigne();
  const consultation = useConsultationHorsLigne();
  const affichee = enLigne && !consultation && url !== null && url !== urlEnEchec ? url : null;
  return (
    <span
      data-ui={dataUi}
      className={[styles.vignette, styles[`vignette-${taille}`], className]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
      data-vide={affichee ? undefined : 'true'}
    >
      {affichee ? (
        <img
          className={styles.image}
          src={affichee}
          alt=""
          loading="lazy"
          onError={() => setUrlEnEchec(affichee)}
        />
      ) : (
        <IconeImage className={styles.iconeVide} size={18} strokeWidth={1.25} />
      )}
    </span>
  );
}
